// extracted by mini-css-extract-plugin
export default {"card":"e4-z"};